import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { StarFlourish, MagicHatWithCarrot } from './Decorations';
export function Hero() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.18,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1] as const
      }
    }
  };
  return <section className="relative min-h-[92vh] flex flex-col items-center justify-center pt-24 pb-16 px-4 overflow-hidden bg-parchment" data-id="element-64">
      {/* Confined warm sun glow at the very top — does NOT wash over the headline */}
      <div className="absolute inset-x-0 top-0 h-64 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(ellipse 70% 100% at 50% 0%, rgba(255, 195, 100, 0.45) 0%, rgba(250, 220, 160, 0.18) 40%, rgba(250, 243, 226, 0) 75%)'
    }} data-id="element-65" />
      {/* Very subtle paper grain */}
      <div className="absolute inset-0 bg-noise opacity-[0.07] mix-blend-multiply pointer-events-none" data-id="element-66" />
      {/* Aged-paper edge vignette */}
      <div className="absolute inset-0 bg-paper-edges pointer-events-none" data-id="element-67" />

      {/* Decorative double border frame — vintage playbill */}
      <div className="absolute inset-4 md:inset-8 border-2 border-gold/50 rounded-xl pointer-events-none" data-id="element-68" />
      <div className="absolute inset-5 md:inset-9 border border-carrot/30 rounded-lg pointer-events-none" data-id="element-69" />

      <motion.div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-70">
        <motion.div variants={itemVariants} className="mb-8 relative" data-id="element-71">
          <StarFlourish className="absolute -left-10 top-1/2 -translate-y-1/2 text-gold w-5 h-5 hidden sm:block" delay={0} data-id="element-72" />
          <span className="uppercase tracking-[0.25em] text-xs md:text-sm text-velvet/70 font-semibold" data-id="element-73">
            The Carrot Business Network Presents
          </span>
          <StarFlourish className="absolute -right-10 top-1/2 -translate-y-1/2 text-gold w-5 h-5 hidden sm:block" delay={1.5} data-id="element-74" />
        </motion.div>

        <motion.div variants={itemVariants} className="mb-10" data-id="element-75">
          <MagicHatWithCarrot className="w-28 h-28 md:w-36 md:h-36 mx-auto" data-id="element-76" />
        </motion.div>

        <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl lg:text-8xl font-serif text-velvet leading-[1.05] mb-8 max-w-3xl" data-id="element-77">
          The New <span className="text-carrot italic" data-id="element-78">Magic</span>
          <br data-id="element-79" />
          of the Web
        </motion.h1>

        <motion.div variants={itemVariants} className="flex items-center gap-3 mb-8 text-gold" data-id="element-80">
          <span className="h-px w-12 bg-gold/50" data-id="element-81" />
          <span className="uppercase tracking-[0.2em] text-sm md:text-base font-semibold" data-id="element-82">
            A Morning Talk
          </span>
          <span className="h-px w-12 bg-gold/50" data-id="element-83" />
        </motion.div>

        <motion.p variants={itemVariants} className="text-xl md:text-2xl text-velvet/85 max-w-2xl mx-auto font-light leading-relaxed mb-4" data-id="element-84">
          How AI is transforming web development.
        </motion.p>

        <motion.p variants={itemVariants} className="text-base md:text-lg text-velvet/65 max-w-xl mx-auto font-light leading-relaxed mb-12" data-id="element-85">
          Once the work of long nights and longer sprints — building for the web
          now feels like sleight of hand. Join us, coffee in hand, for a look at
          the tools, the tricks, and what comes next.
        </motion.p>

        <motion.div variants={itemVariants} data-id="element-86">
          <a href="#rsvp" className="group relative inline-flex items-center justify-center px-10 py-4 font-serif text-lg tracking-wide text-parchment bg-carrot overflow-hidden rounded-sm transition-transform hover:scale-105 active:scale-95 box-glow-carrot" data-id="element-87">
            <span className="absolute inset-0 w-full h-full bg-gradient-to-br from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-88" />
            <span className="relative flex items-center gap-2" data-id="element-89">
              Secure Your Seat
              <StarFlourish className="w-4 h-4 text-parchment" data-id="element-90" />
            </span>
          </a>
        </motion.div>
      </motion.div>
    </section>;
}